import * as React from "react";
import { ScoreboardHeaderCell } from "../ScoreboardHeaderCell";
import { ScoreboardIconsOrdered } from "../../../../constants";
export class ScoreboardHeaderRow extends React.PureComponent {
    render() {
        return (React.createElement("tr", { className: "rj-aggregate-scoreboard-row" }, this.props.scoresKeys.map(scoreKey => (scoreKey === "name" ?
            React.createElement(ScoreboardHeaderCell, { key: `heading-${scoreKey}`, columnClass: "rj-aggregate-scoreboard-cell--info", contentClass: "icon i-15 i-o-betslip-info", onClick: this.props.slideUp },
                React.createElement("span", { className: "rj-aggregate-scoreboard-cell-content rj-aggregate-scoreboard-cell-content--info" }, this.props.dict.infoLabel))
            :
                scoreKey !== "participantScoreId" && React.createElement(ScoreboardHeaderCell, { key: `heading-${scoreKey}`, columnClass: "rj-aggregate-scoreboard-cell--score", contentClass: `icon i-12 ${ScoreboardIconsOrdered[scoreKey]}`, onClick: () => { } })))));
    }
}
//# sourceMappingURL=ScoreboardHeaderRow.js.map